import React from "react";
import "./Terms.css";
import {green} from "@material-ui/core/colors";

class TermsAcraAgreement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {...props};
  }

  render() {
    return (
      <div className='arca-agreement'>
        <p><strong>ՏԵՂԵԿԱՏՎՈՒԹՅՈՒՆ ՎԱՐԿԱՅԻՆ ՊԱՏՄՈՒԹՅԱՆ ՎԵՐԱԲԵՐՅԱԼ</strong></p>
        <p>
          Վարկային զեկույցը գրավոր կամ էլեկտրոնային փաստաթուղթ է, որը պարունակում է
          վարկային տեղեկատվության սուբյեկտի (ֆիզիկական կամ իրավաբանական) և նրա
          կողմից ստանձնած տնտեսվարող կազմակերպությունների նկատմամբ ֆինանսական
          պարտավորությունների կատարման վերաբերյալ տեղեկատվություն:
        </p>

        <p>
          Զեկույցը կազմված է ԱՔՌԱ անդամ կազմակերպություններից ստացված տվյալների
          հիման վրա և արտացոլում է հարցման պահից վերջին 5 տարվա վարկային տվյալները:
        </p>

        <p>
          «Միկրո Կապիտալ Հայաստան» ՈւՎԿ ՓԲԸ-ն որոշումների կայացման համար կիրառում է
          սեփական վարկարժանության գնահատման համակարգը, որի մաս են կազմում և կարող
          են ունենալ բացասական ազդեցություն որոշման կայացման վրա Սպառողի վարկային
          պատմությունը, այդ թվում՝

          <ul className='line-list'>
            <li>նախորդ 12 (տասներկու) ամիսների ընթացքում ժամկետանց օրերի քանակը,</li>
            <li>գործող վարկերի քանակը,</li>
            <li>վարկային ծանրաբեռնվածության աստիճանը</li>
          </ul>
        </p>

        <p>
          «Միկրո Կապիտալ Հայաստան» ՈւՎԿ ՓԲԸ կատարում է վարկային պատմության
          հարցումներ հետևյալ նպատակներով.
          <ul>
            <li>
              նոր վարկ տրամադրելու համար (հարցման ձևանմուշներ՝ «նոր վարկային դիմում»,
              «փոխկապակցված անձ»),
            </li>
            <li>
              երաշխավորության պայմանագիր կնքելու համար (հարցման ձևանմուշ՝ «երաշխավոր
              անձ»),
            </li>
            <li>
              գործող պարտավորության դեպքում մշտադիտարկում իրականացնելու համար
              («գործող վարկի մոնիտորինգ»),
            </li>
            <li>
              գործող պարտավորության դեպքում նոր առաջարկներ ներկայացնելու համար
              («գործող վարկի մոնիտորինգ»)
            </li>
            <li>
              այլ նպատակների համար, այդ թվում՝ «նոր աշխատակից» դիմում, «Ֆայկո Սքոր
              միջակայք» և այլն
            </li>
          </ul>
        </p>

        <p>
          Նոր վարկ տրամադրելու, երաշխավոր հանդես գալու և նոր աշխատակցի համար
          կատարվող հարցումները իրականացվում են համապատասխան հայտ ներկայացնելու
          դեպքում, իսկ մշտադիտարկումների և նոր առաջարկների դեպքում
          պարբերականությունը սահմանվում է «Միկրո Կապիտալ Հայաստան» ՈւՎԿ ՓԲԸ ներքին
          ընթացակարգերով:
        </p>

        <p>
          Սպառողի կողմից ներկայացվող վարկային դիմումների քանակը (թվային մեծությունը)
          մեծ հավանկանությամբ բացասական ազդեցություն է ունենում սպառողի վարկային
          ամփոփ գնահատականի վրա:
        </p>

        <p>
          Միաժամանակ, ԱՔՌԱ Սքոր (ՖԱՅԿՈ Սքոր) գնահատականը մեծ հավանականությամբ
          իջեցնում են հետևյալ նպատակով կատարված հարցումները ՝
          <ul>
            <li>
              Նոր վարկային դիմում
            </li>
            <li>
              Երաշխավոր անձ (նոր վարկային դիմում ենթանպատակ)
            </li>
          </ul>
        </p>

        <p>
          Իսկ, ՖԱՅԿՈ Սքոր գնահատականի վրա ազդեցություն չեն ունենում կամ ցածր
          հավանականությամբ ազդում են հետևյալ նպատակով կատարված հարցումները՝
          <ul>
            <li>
              Գործող վարկի մոնիտորինգ
            </li>
            <li>
              Երաշխավոր անձ (գործող վարկ, գործող երաշխավորի մոնիտորինգ
              ենթանպատակներ)
            </li>
            <li>
              Փոխկապակցված անձ
            </li>
            <li>
              Այլ բանկային ծառայություններ
            </li>
            <li>
              Ֆայկո Սքոր միջակայք
            </li>
          </ul>
        </p>

        <p>
          Վարկային տեղեկատվության հարցումներ կատարելու համաձայնությունը պարտադիր
          պայման է հայտ ներկայացնելու համար։
        </p>

        <p><strong>ՀԱՄԱՁԱՅՆՈՒԹՅՈՒՆ</strong></p>

        <ol>
          <li>
            «Միկրո Կապիտալ Հայաստան ՈւՎԿ» ՓԲԸ-ն առանց ինձ նախապես տեղեկացնելու
            հարցումներ կատարի և ստանա տեղեկատվություն՝
          </li>

          <ul>
            <li>
              ԱՔՌԱ Քրեդիտ Ռեփորթինգ» ՓԲԸ-ից, այլ վարկային բյուրոներից՝ իմ և/կամ
              կազմակերպության ներկա և անցյալ ֆինանսական պարտավորությունների, երրորդ
              անձանց պարտավորությունների երաշխավոր լինելու մասին, ստանա ցանացած այլ
              տվյալ, որը կարող է առնչվել ինձ և/կամ կազմակերպության հետ համապատասխան
              վարկային (փոխառություն) և այլ պայմանագրեր կնքելու վերաբերյալ որոշում
              կայացնելիս, ինչպես նաև ինձ և/կամ կազմակերպության հետ վարկային
              (փոխառության և այլն) և այլ պայմանագրեր կնքելու դեպքում տվյալ պայմանագրի
              գործողության ողջ ընթացքում ցանկացած պահի ստանա իմ և/կամ
              կազմակերպության ֆինանսական պարտավորությունների վերաբերյալ
              տեղեկություններ և այլ տվյալներ։
            </li>
            <li>
              «Էլեկտրոնային կառավարման ենթակառուցվածքների ներդրումների գրասենյակից»`
              իմ անձնական տվյալների մասին:
            </li>
            <li>
              ՀՀ օրենսդրությամբ սահմանված հանրային տվյալների բազաներ մշակող անձանցից,
              իրավապահ մարմիններից, պետական և/կամ տեղական ինքնակառավարման
              մարմիններից` իմ և/կամ կազմակերպության վերաբերյալ ցանկացած
              տեղեկատվություն (այդ թվում՝ անձնական տվյալներ):
            </li>
          </ul>

          <br/>

          <li>
            «Միկրո Կապիտալ Հայաստան ՈւՎԿ» ՓԲԸ կողմից իմ և/կամ Կազմակերպության
            տվյալները (այդ թվում՝ անձնական տվյալները) փոխանցվեն «ԱՔՌԱ Քրեդիտ
            Ռեփորթինգ» ՓԲԸ, ՀՀ Կենտրոնական բանկ, այլ վարկային բյուրոների և
            հաճախորդների վերաբերյալ տվյալներ մշակող այլ անձանց և/կամ պետական
            մարմիններին:
          </li>

          <li>
            Սույն համաձայնությունը բոլոր նպատակների համար կիրառելի է «Միկրո Կապիտալ
            Հայաստան ՈւՎԿ» ՓԲԸ հետ հարաբերությունների գործողության ամբողջ
            ժամանակահատվածում:
          </li>
        </ol>

        <p><strong><i>Հարգելի՛ Հաճախորդ,</i></strong></p>

        <p>
          Սույն համաձայնությունը կիրառելի է Ձեր և «Միկրո Կապիտալ Հայաստան ՈՒՎԿ» ՓԲԸ
          միջև կնքված պայմանագրերի գործողության ամբողջ ժամանակահատվածի համար:
          «Անձնական տվյալների պաշտպանության մասին» ՀՀ օրենքով սահմանված կարգով
          Դուք ունեք Ձեր տվյալների մշակման դադարեցման պահանջ ներկայացնելու իրավունք:
        </p>

        <p>
          Ձեր կողմից հայցվող դադարեցման պահանջը ներկայացվում է «Միկրո Կապիտալ
          Հայաստան» ՈՒՎԿ ՓԲԸ-ին գրավոր դիմումի միջոցով, որին ընթացք է տրվում միայն այն
          դեպքում, երբ դիմումում ներկայացված պահանջը հնարավոր է բավարարել` հիմք
          ընդունելով «Միկրո Կապիտալ Հայաստան» ՈՒՎԿ ՓԲԸ-ի ներքին իրավական ակտերը և
          անձնական տվյալների մշակման անհրաժեշտության բացակայությունը:
        </p>

        <br/>
        <br/>

        <p>
          <strong>
            <i>
              Սույն համաձայնությունը կարդացել եմ, հաստատում եմ, որ այն ինձ
              համար ամբողջությամբ հասկանալի ու ընդունելի է։
            </i>
          </strong>
        </p>
      </div>
    );
  }
}

export default TermsAcraAgreement;
